import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys.js";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";
//----------------------------------------------------------------

const getPromoCodeValidation = async (data) => {
	try {
		const { promoCode, oktaToken } = { ...data };
		const returnResponse = await request({
			url: `/validatePromoCode/${promoCode}`,
			method: "GET",
			...(oktaToken != null && {
				oktaAccessToken: oktaToken,
			}),
		});
		return returnResponse;
	} catch (e) {
		console.log("ERROR ", e);
		return e;
	}
};

export const useValidatePromoCode = (data) =>
	useQuery({
		queryKey: [queryKeys.PROMO_CODE_GET, data?.promoCode],
		queryFn: async () => await getPromoCodeValidation(data),
		refetchOnWindowFocus: false,
		enabled: !!data?.promoCode,
	});
